// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Uuid from "uuid";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Client from "@apollo/client";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as PromotionEditActions from "./PromotionEditActions.res.js";
import * as PromotionStatusBadge from "./PromotionStatusBadge.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
function keyExtractor(row) {
  return row.id;
}
let Row = {
  keyExtractor: keyExtractor
};
function tableColumns(editing, promotionCreated) {
  return [{
    key: "shopName",
    name: I18n.t("Shop"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      }
    },
    render: param => JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: param.data.shopName
      }),
      spaceY: "normal"
    })
  }, {
    key: "status",
    name: I18n.t("Status"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 120
      }
    },
    render: param => {
      let status = param.data.status;
      if (status !== undefined) {
        return JsxRuntime.jsx(PromotionStatusBadge.make, {
          status: status
        });
      } else {
        return null;
      }
    }
  }, {
    key: "action",
    layout: {
      hidden: !promotionCreated || editing,
      width: {
        NAME: "fr",
        VAL: 0
      },
      alignX: "flexEnd"
    },
    render: param => {
      let match = param.data;
      let status = match.status;
      if (status !== undefined) {
        return JsxRuntime.jsx(PromotionEditActions.make, {
          variation: "menuItem",
          id: match.id,
          status: status
        });
      } else {
        return null;
      }
    }
  }];
}
let Raw = {};
let query = Client.gql(["query PricesQuery($after: String)  {\nprices(first: 50, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.prices;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}
function serialize(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.name;
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      id: value$6,
      name: value$5,
      shop: shop
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let prices = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    prices: prices
  };
}
function serializeVariables(inp) {
  let a = inp.after;
  return {
    after: a !== undefined ? a : undefined
  };
}
function makeVariables(after) {
  return {
    after: after
  };
}
function makeDefaultVariables() {
  return {
    after: undefined
  };
}
let PricesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let PricesQuery_refetchQueryDescription = include.refetchQueryDescription;
let PricesQuery_use = include.use;
let PricesQuery_useLazy = include.useLazy;
let PricesQuery_useLazyWithVariables = include.useLazyWithVariables;
let PricesQuery = {
  PricesQuery_inner: PricesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: PricesQuery_refetchQueryDescription,
  use: PricesQuery_use,
  useLazy: PricesQuery_useLazy,
  useLazyWithVariables: PricesQuery_useLazyWithVariables
};
function runScanPrices(pricesFetch, cursor, dataOpt, onDone, param) {
  let data = dataOpt !== undefined ? dataOpt : [];
  Future.mapOk(FuturePromise.fromPromise(pricesFetch(cursor)), undefined, response => {
    if (response.TAG !== "Ok") {
      return onDone("Error");
    }
    let match = response._0;
    let match$1 = match.data.prices;
    let match$2 = match$1.pageInfo;
    let match$3 = match$2.hasNextPage;
    if (match$3 !== undefined && match$3) {
      if (match.error !== undefined) {
        return onDone("Error");
      } else {
        return runScanPrices(pricesFetch, match$2.endCursor, Belt_Array.concatMany([data, match$1.edges]), onDone, undefined);
      }
    }
    if (match.error !== undefined) {
      return onDone("Error");
    } else {
      return onDone({
        TAG: "Success",
        _0: Belt_Array.concatMany([data, match$1.edges])
      });
    }
  });
}
function makeEligibleShopsFromPrices(prices, shops, selectedPriceName) {
  return Stdlib_Array.filterMap(shops, shop => {
    let match = prices.find(param => {
      let price = param.node;
      if (price.shop.id === shop.id && price.name === selectedPriceName) {
        return shop.kind !== "WAREHOUSE";
      } else {
        return false;
      }
    });
    if (match !== undefined) {
      return {
        id: Uuid.v4(),
        creatorIdentifier: "",
        shopId: shop.id,
        shopName: shop.name,
        priceId: match.node.id,
        status: undefined,
        selected: false
      };
    }
  });
}
function PromotionEditFormManagementTableCard(props) {
  let onRequestShopsUpdate = props.onRequestShopsUpdate;
  let selectedPriceName = props.selectedPriceName;
  let campaigns = props.campaigns;
  let promotionCreated = props.promotionCreated;
  let editing = props.editing;
  let shops = Auth.useShops();
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = React.useState(() => "Loading");
  let setStatus = match[1];
  let status = match[0];
  React.useEffect(() => {
    let pricesFetch = after => apolloClient.rescript_query({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    }, undefined, undefined, "NetworkOnly", undefined, {
      after: after
    });
    runScanPrices(pricesFetch, undefined, undefined, result => setStatus(param => result), undefined);
    return () => onRequestShopsUpdate([]);
  }, []);
  let columns = React.useMemo(() => tableColumns(editing, promotionCreated), [promotionCreated, editing]);
  let rows = React.useMemo(() => {
    if (typeof status !== "object" || promotionCreated || campaigns.length !== 0) {
      return campaigns;
    } else {
      return makeEligibleShopsFromPrices(status._0, shops, selectedPriceName);
    }
  }, [status, campaigns]);
  let onSelectChange = React.useCallback(selectedRowsKeys => {
    let tmp;
    if (typeof selectedRowsKeys !== "object") {
      tmp = rows.map(campaign => ({
        id: campaign.id,
        creatorIdentifier: campaign.creatorIdentifier,
        shopId: campaign.shopId,
        shopName: campaign.shopName,
        priceId: campaign.priceId,
        status: campaign.status,
        selected: true
      }));
    } else {
      let keys = selectedRowsKeys._0;
      tmp = rows.map(campaign => {
        if (keys.some(key => key === campaign.id)) {
          return {
            id: campaign.id,
            creatorIdentifier: campaign.creatorIdentifier,
            shopId: campaign.shopId,
            shopName: campaign.shopName,
            priceId: campaign.priceId,
            status: campaign.status,
            selected: true
          };
        } else {
          return {
            id: campaign.id,
            creatorIdentifier: campaign.creatorIdentifier,
            shopId: campaign.shopId,
            shopName: campaign.shopName,
            priceId: campaign.priceId,
            status: campaign.status,
            selected: false
          };
        }
      });
    }
    onRequestShopsUpdate(tmp);
  }, [rows]);
  let match$1 = Auth.useScope();
  let tmp;
  tmp = match$1.TAG === "Organisation" ? {
    style: {
      width: "100%"
    }
  } : {
    style: {
      opacity: 0,
      width: "0px"
    }
  };
  let newrecord = {
    ...tmp
  };
  return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsxs(Card.make, {
    children: [promotionCreated ? null : JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Once the draft is saved, you will no longer be able to edit the selection."),
        variation: "normal"
      }),
      spaceX: "large",
      spaceTop: "small",
      spaceBottom: "normal"
    }), rows.length === 0 ? JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    }) : JsxRuntime.jsx(TableView.make, {
      data: {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: rows
        }
      },
      columns: columns,
      keyExtractor: keyExtractor,
      selectionEnabled: !promotionCreated,
      initialAllSelected: !promotionCreated,
      maxHeight: 292,
      onSelectChange: onSelectChange
    })],
    title: I18n.t("Campaign management by shop"),
    variation: "table",
    grow: true
  }), newrecord));
}
let make = React.memo(PromotionEditFormManagementTableCard, (oldProps, newProps) => {
  if (oldProps.campaigns === newProps.campaigns && oldProps.editing === newProps.editing && oldProps.promotionCreated === newProps.promotionCreated) {
    return oldProps.selectedPriceName === newProps.selectedPriceName;
  } else {
    return false;
  }
});
export { Row, tableColumns, PricesQuery, runScanPrices, makeEligibleShopsFromPrices, make };
/* query Not a pure module */